import { useAtom } from "@reatom/npm-react"
import { useQuery } from "@tanstack/react-query"

import { Checkbox, Dropdown, Label, Text } from "ui-kit/components-branded/index"
import { SessionTimeInterval } from "utils/interfaces"
import { sessionTimeIntervalsAtom } from "modules/PsyCatalog/common/models/filterForm"
import { formatLabel } from "modules/PsyCatalog/common/Filters/formatLabel"
import { httpClient } from "utils/infrastructure/httpClient"

function getDisplayValue(
    interval: SessionTimeInterval[],
    selectedIntervals: SessionTimeInterval[]
) {
    return interval.filter((interval) => selectedIntervals.includes(interval))
}

export function SessionTimeIntervalsDropdown() {
    const [value] = useAtom(sessionTimeIntervalsAtom.inputValue)

    const { data, status } = useQuery<SessionTimeInterval[]>(
        ["session_time_intervals"],
        () =>
            httpClient.get(
                `session_time_intervals?offset_from_utc_minutes=${-new Date().getTimezoneOffset()}`
            ),
        {
            staleTime: Infinity,
        }
    )

    return (
        <>
            <Label htmlFor="session_time" className="label-with-opacity">
                Время сессии
            </Label>
            <Dropdown
                multiSelect
                label={formatLabel(
                    status,
                    data,
                    (data) =>
                        getDisplayValue(data, value)
                            .map((item) => item.begin)
                            .join(", "),
                    "Любое"
                )}
                className="is-fullwidth is-old"
            >
                <div className="ml-2">
                    <Text isAccent>В вашей часовой зоне</Text>
                </div>
                {data?.map((interval) => (
                    <Dropdown.Item key={interval.begin}>
                        <Checkbox
                            value={interval.begin}
                            onChange={() => sessionTimeIntervalsAtom.onChange(interval)}
                            checked={value.includes(interval)}
                            className="is-fullwidth mr-0"
                        >
                            {interval.begin}&nbsp;{interval.high_demand ? "🔥 высокий спрос" : ""}
                        </Checkbox>
                    </Dropdown.Item>
                ))}
            </Dropdown>
        </>
    )
}
